<template>
  <div>
    <vue-header title="舌诊" isReturn="true"/>
    <camera type="2"/>
  </div>
</template>
<script>
  import vueHeader from "@/components/header";
  import camera from "@/components/camera";
  export default {
    name: "step2",
    components: {
      vueHeader,
      camera
    }
  };
</script>
